export default "__VITE_ASSET__DcxLok$l__"